import React from 'react';

export const SectionHeader = ({ label, title, description }) => {
  return (
    <div className="text-center mb-12 max-w-3xl mx-auto fade-in" data-testid="section-header">
      {label && (
        <div className="text-xs uppercase font-semibold tracking-widest mb-4" style={{ color: '#1570EF' }}>
          {label}
        </div>
      )}
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6" style={{ color: '#1B3A6B' }}>
        {title}
      </h2>
      <div className="w-12 h-1 bg-[#1570EF] mx-auto mb-6" />
      {description && (
        <p className="text-base sm:text-lg" style={{ color: '#1E293B' }}>
          {description}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;